const SPECIAL_TALENTMOD_KEYS = new Set([
    "Crit", "CritCorrection", "Burly", "Defensive", "Deflection", "UnarmedQualities", "ICBuffs",
]);

const applyItemChangeBuffs = (weap, itemModTalents, opts = {}) => {
    const { forceRating = 0, skillRanksFor = () => 0, injectedProps = [] } = opts;
    if (!weap.TalentMods) { weap.TalentMods = {}; }
    const tm = weap.TalentMods;

    const reverseDamage = (amt) => {
        if (!amt) { return; }
        if (weap.Damage != null) { weap.Damage = parseInt(weap.Damage) - amt; }
        else { weap.DamageAdd = (parseInt(weap.DamageAdd) || 0) - amt; }
    };
    const reverseCrit = (amt) => { if (amt) { weap.Crit = parseInt(weap.Crit) - amt; } };
    const reverseHP = (amt) => { if (amt) { weap.HP = Math.max((parseInt(weap.HP) || 0) - amt, 0); } };
    const reverseEncumbrance = (amt) => { if (amt) { weap.Encumbrance = (parseInt(weap.Encumbrance) || 0) - amt; } };

    const qualityDec = {};
    const addedKeys = new Set();
    const noteQualityReverse = (qk, amt, added) => {
        qualityDec[qk] = (qualityDec[qk] || 0) + amt;
        if (added) { addedKeys.add(qk); }
    };

    (tm.ICBuffs || []).forEach((rec) => {
        if (rec.kind === "damage") { reverseDamage(rec.amt); }
        else if (rec.kind === "crit") { reverseCrit(rec.amt); }
        else if (rec.kind === "hp") { reverseHP(rec.amt); }
        else if (rec.kind === "encumbrance") { reverseEncumbrance(rec.amt); }
        else if (rec.kind === "quality") { noteQualityReverse(rec.qk, rec.amt, rec.added); }
    });

    for (const key of Object.keys(tm)) {
        if (SPECIAL_TALENTMOD_KEYS.has(key)) { continue; }
        const val = tm[key];
        if (key.endsWith("_DamageChange")) { reverseDamage(parseInt(val) || 0); delete tm[key]; }
        else if (key.endsWith("_CritChange")) { reverseCrit(parseInt(val) || 0); delete tm[key]; }
        else if (key.endsWith("_HPChange")) { reverseHP(parseInt(val) || 0); delete tm[key]; }
        else if (typeof val !== "object") { noteQualityReverse(key, parseInt(val) || 0, true); delete tm[key]; }
    }

    if (weap.Qualities) {
        Object.keys(qualityDec).forEach((qk) => {
            const q = weap.Qualities.find((x) => x.Key === qk);
            if (!q) { return; }
            q.Count = (parseInt(q.Count) || 0) - qualityDec[qk];
        });
        weap.Qualities = weap.Qualities.filter((q) => !(addedKeys.has(q.Key) && (parseInt(q.Count) || 0) <= 0));
    }

    const ledger = [];
    const applyDamage = (amt) => {
        if (weap.Damage != null) { weap.Damage = parseInt(weap.Damage) + amt; }
        else { weap.DamageAdd = (parseInt(weap.DamageAdd) || 0) + amt; }
        ledger.push({ kind: "damage", amt });
    };
    const applyCrit = (amt) => {
        const nc = Math.max(parseInt(weap.Crit) + amt, 1);
        const actual = nc - parseInt(weap.Crit);
        weap.Crit = nc;
        ledger.push({ kind: "crit", amt: actual });
    };
    const applyHP = (amt) => {
        const base = parseInt(weap.HP) || 0;
        const nh = Math.max(base + amt, 0);
        weap.HP = nh;
        ledger.push({ kind: "hp", amt: nh - base });
    };
    const applyEncumbrance = (amt) => {
        const base = parseInt(weap.Encumbrance) || 0;
        const ne = Math.max(base + amt, 0);
        weap.Encumbrance = ne;
        ledger.push({ kind: "encumbrance", amt: ne - base });
    };

    for (const modTalent of itemModTalents || []) {
        const changes = modTalent?.data?.ItemChanges;
        if (!changes) { continue; }
        for (const mod of changes) {
            const matches =
                (!mod.SkillKey || weap.SkillKey === mod.SkillKey) &&
                (!mod.ItemProperty || weap[mod.ItemProperty] || injectedProps.includes(mod.ItemProperty)) &&
                (!mod.ItemKey || mod.ItemKey === weap.Key);
            if (!matches) { continue; }

            if (mod.QualityChanges) {
                for (const qc of mod.QualityChanges) {
                    if (!weap.Qualities) { weap.Qualities = []; }
                    const existing = weap.Qualities.find((q) => q.Key === qc.Key);
                    let ratingBase;
                    if (qc.UseForceRating) { ratingBase = parseInt(forceRating) || 0; }
                    else if (qc.UseSkillRanks) { ratingBase = skillRanksFor(qc.UseSkillRanks); }
                    else { ratingBase = parseInt(qc.Count) || 0; }
                    const newCount = ratingBase * modTalent.count;

                    if (existing && !mod.AddQuality) {
                        existing.Count = (parseInt(existing.Count) || 0) + newCount;
                        ledger.push({ kind: "quality", qk: qc.Key, amt: newCount, added: false });
                    } else if (mod.AddQuality) {
                        if (existing) {
                            const delta = Math.max(newCount - (parseInt(existing.Count) || 0), 0);
                            if (delta) {
                                existing.Count = (parseInt(existing.Count) || 0) + delta;
                                ledger.push({ kind: "quality", qk: qc.Key, amt: delta, added: false });
                            }
                        } else {
                            weap.Qualities.push({ Key: qc.Key, Count: newCount });
                            ledger.push({ kind: "quality", qk: qc.Key, amt: newCount, added: true });
                        }
                    }
                }
            }

            if (mod.DamageChange) { applyDamage(parseInt(mod.DamageChange) * modTalent.count); }
            if (mod.CritChange) { applyCrit(parseInt(mod.CritChange) * modTalent.count); }
            if (mod.HPChange) { applyHP(parseInt(mod.HPChange) * modTalent.count); }
            if (mod.EncumbranceChange) { applyEncumbrance(parseInt(mod.EncumbranceChange) * modTalent.count); }
        }
    }

    if (ledger.length) { tm.ICBuffs = ledger; } else { delete tm.ICBuffs; }
    return weap;
};

export default applyItemChangeBuffs;
